module.exports = __webpack_public_path__ + "img/img_08.a8d96363.webp";